import { Avatar, Box, Icon, Tooltip, Typography } from '@mui/material';

import { useFiles } from 'Lib/components/common/table/filesTable/context';
import ModalTrigger from 'Lib/muiComponents/modal/ModalTrigger';
import { getFileIcon, isPath } from 'Lib/utilities/files';
import openExternalLink from 'Lib/utilities/openExternalLink';

const FileName = ({ data, modal = false, getImageUrl }) => {
    if (!data) return null;

    const { moveFile } = useFiles();

    const avatarSize = modal ? '40px' : '56px';
    const avatarBgColor = modal ? 'inherit' : 'common.lightblue';

    const openExternalPreview = () => openExternalLink(getImageUrl(data));

    const renderAvatar = () => {
        if (isPath(data)) {
            return (
                <Avatar sx={{ width: avatarSize, height: avatarSize, bgcolor: avatarBgColor, cursor: 'pointer' }}>
                    <Icon
                        sx={{
                            color: '#343434',
                            fontSize: '40px'
                        }}
                    >
                        {data.pathID == moveFile.newDirectory ? 'folder_open' : 'folder'}
                    </Icon>
                </Avatar>
            );
        } else if (data.file.previewFileName) {
            const imageAvatar = () => (
                <Avatar
                    sx={{ width: avatarSize, height: avatarSize }}
                    src={getImageUrl(data, 'thumbnail')}
                    imgProps={{
                        draggable: 'false',
                        onDragStart: event => event.preventDefault()
                    }}
                />
            );

            return modal ? (
                <ModalTrigger name="File Preview" state={data.file}>
                    {imageAvatar()}
                </ModalTrigger>
            ) : (
                <ModalTrigger name="File Preview" state={data.file}>
                    <Tooltip arrow title="Preview File" placement="top">
                        {imageAvatar()}
                    </Tooltip>
                </ModalTrigger>
            );
        } else {
            return (
                <ModalTrigger name="File Preview" state={data.file}>
                    <Tooltip arrow title="Preview File" placement="top">
                        <Avatar sx={{ width: avatarSize, height: avatarSize, bgcolor: avatarBgColor }}>
                            <Icon sx={{ color: '#343434', fontSize: '40px' }}>{getFileIcon(data)}</Icon>
                        </Avatar>
                    </Tooltip>
                </ModalTrigger>
            );
        }
    };

    return (
        <Box display="flex" gap={2}>
            {renderAvatar()}
            <Box display="flex" flexDirection="column" width={modal ? '125px' : '290px'}>
                <Typography
                    noWrap
                    sx={{
                        mt: isPath(data) ? 0 : 2,
                        color: modal ? 'inherit' : 'common.blue',
                        cursor: 'pointer'
                    }}
                >
                    {isPath(data) ? (
                        data.path
                    ) : (
                        <Box component="span" onClick={openExternalPreview}>
                            {data.file.title}
                        </Box>
                    )}
                </Typography>
                {isPath(data) && <Box fontSize="11px">{Number(data.fileCount) + Number(data.folderCount)} Items</Box>}
            </Box>
        </Box>
    );
};

export default FileName;
